import Card from '@/components/Card';
import colors from '@/design/colors';
import gaps from '@/design/gaps';
import styled from 'styled-components';
import Markdown from '@/components/Markdown';

export const Container = styled(Card)`
  display: flex;
  flex-direction: column;
  row-gap: ${gaps.defaultGap};
  padding: 24px;

  position: relative;

  width: 100%;

  & + div {
    margin-top: 24px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 36px;

  h2 {
    font-weight: 600;
    font-size: 20px;
    line-height: 25px;
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: right;
    column-gap: 8px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${gaps.extraSmallGap};
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  flex: 1;
  gap: ${gaps.extraSmallGap};
`;

export const FlexRow = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;

  width: 100%;
  gap: ${gaps.extraSmallGap};
`;

export const ListaArtefatos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const ArtefatoCard = styled(Card)`
  display: flex;
  flex-direction: column;
  padding: 17px 16px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid ${colors.gray100};
  box-shadow: none;
  background: ${colors.gray50};
`;

export const ArtefatoCardTitle = styled.div`
  color: ${colors.blackAlpha100};

  /* -span */
  font-family: 'Source Sans Pro';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const ArtefatoCardBody = styled(Markdown)`
  color: ${colors.gray300};

  /* Text 14 */
  font-family: 'Source Sans Pro';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const TipoSolicitacaoLabelTitle = styled.span``;
